import { DOCS_URL } from "../../../config/constants.js";
import Testimonial from "./Testimonial.svelte";

export default {
    component: Testimonial,
    name: "Testimonial",
    description: "Customer testimonial with quote and attribution",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/quote.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fd9cb859336124b7cb3031058979212dd",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-testimonial--docs`,
    inputs: [
        {
            friendlyName: "Header",
            name: "header",
            type: "longText",
        },
        {
            friendlyName: "CTA To",
            name: "ctaTo",
            type: "text",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "text",
        },
        {
            friendlyName: "Testimonials",
            name: "testimonials",
            type: "list",
            subFields: [
                {
                    friendlyName: "Testimonial",
                    name: "testimonial",
                    type: "reference",
                    model: "testimonials",
                },
            ],
        },
    ],
};
